// export const BASE_URL = 'https://localhost:44360/'
export const BASE_URL = 'https://altusindonesia.com/'
